export default {
  listItems: [],
  totalCount: 0
};
